<template>
  <component
    :is="tag"
    :id="id"
    ref="el"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  offsetGap: {
    type: Number,
    default: 10,
  },

  id: {
    type: String,
    required: true,
  },

  tag: {
    type: String,
    default: 'div',
  },
})

const observer = ref({})
const resizeTimer = ref(0)
const el = ref()

const totalOffset = computed(() => {
  let offset = props.offsetGap
  if (navbar.value) offset += navbar.value.offsetHeight
  if (anchorsNavbar.value) offset += anchorsNavbar.value.offsetHeight
  return offset
})

const anchorsNavbar = computed(() => {
  return document.querySelector('#js-anchor-links')
})

const navbar = computed(() => {
  return document.querySelector('#js-navbar')
})

const init = () => {
  const windowHeight = window.innerHeight
  const bottomPercentOffset = Math.round(((windowHeight - totalOffset.value) * 100) / windowHeight)

  const options = {
    rootMargin: `${(totalOffset.value + 1) * -1}px 0px -${bottomPercentOffset}%`,
  }

  observer.value = new IntersectionObserver(toggleAnchorLink, options)
  observer.value.observe(el.value)

  window.addEventListener('resize', resize)
}

const toggleAnchorLink = (entries) => {
  for (const entry of entries) {
    const anchorLink = anchorsNavbar.value.querySelector(`[href="#${props.id}"]`)

    if (entry.isIntersecting) {
      if (anchorLink) anchorLink.classList.add('active')
    } else if (anchorLink) anchorLink.classList.remove('active')
  }
}

const resize = () => {
  if (window.requestAnimationFrame) {
    destroy()
    init()
  } else {
    clearTimeout(resizeTimer.value)
    resizeTimer.value = setTimeout(() => {
      destroy()
      init()
    }, 500)
  }
}

const destroy = () => {
  observer.value.unobserve(el.value)
  window.removeEventListener('resize', resize)
}

onMounted(() => {
  if (anchorsNavbar.value) init()
})

onBeforeUnmount(() => {
  if (anchorsNavbar.value) destroy()
})
</script>
